import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import moment from 'moment';

import {
    Chart,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartTooltip,
    ChartTitle,
    ChartValueAxis,
    ChartValueAxisItem,
} from '@progress/kendo-react-charts';

import BobLoadingMask from '../../../components/BobLoadingMask';

const FutureSavingsGraph = ({
    bobLoading,
    dashboardEndTimeStamp,
    dashboardStartTimeStamp,
    data = [],
    hasInitialized,
    ...props
}) => {

    const [scoreChartHeight, setScoreChartHeight] = useState('80vh');
    const minWidth2560 = matchMedia('(min-width: 2560px');
    const zoom125 = matchMedia('(min-resolution: 1.25dppx');
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        let target = {name: 'Target', data: []};
        let actual = {name: 'Actual', data: []};
        let forecasted = { name: 'Forecasted', data: [] };

        const offset = moment().utcOffset();

        data.forEach((item, index) => {
            moment().local().format('YYYY-MM-DD');
            const formattedDay = moment(item.day).add(offset * -1, 'minutes');

            if (formattedDay.dayOfYear() === moment(dashboardEndTimeStamp).dayOfYear()) {
                actual.data.push({ timestamp: new Date(formattedDay), value: item.dailyActualEnergyUse });
                forecasted.data.push({ timestamp: new Date(formattedDay), value: item.dailyPredictedEnergyUse });

            } else if (formattedDay.dayOfYear() < moment(dashboardEndTimeStamp).dayOfYear()) {
                actual.data.push({ timestamp: new Date(formattedDay), value: item.dailyActualEnergyUse });
            } else {
                forecasted.data.push({ timestamp: new Date(formattedDay), value: item.dailyPredictedEnergyUse });
            }

            target.data.push({ timestamp: new Date(formattedDay), value: item.dailyEnergyUseTarget });
        });

        setChartData([target, actual, forecasted]);
    }, [data]);

    const updateScoreChart2560 = (e) => {
        if (e.matches) {
            setScoreChartHeight('70vh');
        }
        else {
            setScoreChartHeight('80vh');
        }
    };

    const mqlZoom125 = (e) => {
        if (e.matches) {
            setScoreChartHeight('49vh');
        }
        else {
            setScoreChartHeight('60vh');
        }
    };

    useEffect(() => {
        return () => {
            minWidth2560.removeEventListener('change', updateScoreChart2560);
            zoom125.removeEventListener('change', mqlZoom125);
        };
    }, []);

    useEffect(() => {
        if (window.devicePixelRatio === 1) {
            setScoreChartHeight('60vh');
        }
        else {
            setScoreChartHeight('49vh');
        }

        minWidth2560.addEventListener('change', updateScoreChart2560);
        zoom125.addEventListener('change', mqlZoom125);

        const mediaQuery = window.matchMedia('(min-width: 2560px)');
        if (mediaQuery.matches) {
            updateScoreChart2560(mediaQuery);
        }

    }, []);

    const calculateStart = () => {
        const start = moment(dashboardStartTimeStamp);
        const end = moment(dashboardEndTimeStamp);


        const days = Math.round(moment.duration(end.diff(start)).asDays());
        return days;
    };

    const categoryPlotBands = [
        {
            from:    0,
            to:      calculateStart() + 0.5,
            color:   '#000',
            opacity: 0.05,
            label:   {
                text:   'Baseline Period',
                font:   '18px sans-serif',
                color:  '#444',
                margin: 10,
                align:  'center'
            },
        },
    ];

    return (
        <div>
            <div>
                <Chart
                    style={{
                        height: scoreChartHeight
                    }}
                    pannable={{ lock: 'y' }}
                    zoomable={{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }}
                >
                    <ChartTitle text={'Future Savings'} align="left" font="12pt sans-serif" />
                    <ChartTooltip
                        shared={true} visible={true} //render={sharedTooltipRender}
                        background="#FFFFFF"
                        opacity={.95}
                    />
                    <ChartCategoryAxis>
                        <ChartCategoryAxisItem
                            baseUnit="auto"
                            maxDivisions={12}
                            labels={{ visible: true }}
                            plotBands={categoryPlotBands}
                        />
                    </ChartCategoryAxis>
                    <ChartValueAxis>
                        <ChartValueAxisItem
                            title={{
                                text: 'kWh/Day',
                            }}
                        />
                    </ChartValueAxis>
                    <ChartLegend position="top" orientation="horizontal" visible={true} />
                    <ChartSeries>
                        {chartData.map((item, index) => (
                            <ChartSeriesItem
                                type="line"
                                dashType={index === 2 ? 'dash' : null}
                                markers={{ visible: false }}
                                categoryField="timestamp"
                                name={item.name}
                                key={index}
                                data={item.data}
                                field="value"
                                // eslint-disable-next-line react/style-prop-object
                                style="smooth"
                            />
                        ))}
                    </ChartSeries>
                </Chart>
                {
                    bobLoading.includes('FetchEquipmentFutureSavings') || bobLoading.includes('FetchSiteFutureSavings') || !hasInitialized ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        bobLoading:              state.bob.bobLoading,
        dashboardEndTimeStamp:   state.dashboard.dashboardEndTimeStamp ? state.dashboard.dashboardEndTimeStamp.format() : null,
        dashboardStartTimeStamp: state.dashboard.dashboardStartTimeStamp ? state.dashboard.dashboardStartTimeStamp.format() : null,
    };
};

export default connect(mapStateToProps, null)(FutureSavingsGraph);
